// 注册信息表单校验
const checkRegisterFormFormat = function(registerForm, self) {
  const {
    companyName,
    secondaryIndustry,
    primaryIndustry,
    scale,
    province,
    password,
    checkPassword,
    mobile,
    name,
    authCode,
  } = registerForm;
  if (companyName === '') {
    self.errorMsg = '请输入公司全称';
    return false;
  }
  if (!/^[a-zA-Z\u4E00-\u9FA5]{2,40}$/.test(companyName)) {
    self.errorMsg = '公司全称仅支持中英文 2-40个字符';
    return false;
  }
  if (primaryIndustry === '') {
    self.errorMsg = '请选择一级行业';
    return false;
  }
  if (secondaryIndustry === '') {
    self.errorMsg = '请选择二级行业';
    return false;
  }
  if (scale === '') {
    self.errorMsg = '请选择公司规模';
    return false;
  }
  if (province === '') {
    self.errorMsg = '请选择联系人地址';
    return false;
  }
  if (name === '') {
    self.errorMsg = '请输入联系人姓名';
    return false;
  }
  if (!/^[a-zA-Z\u4E00-\u9FA5]{2,20}$/.test(name)) {
    self.errorMsg = '联系人姓名仅支持中英文 2-20个字符';
    return false;
  }
  if (password === '') {
    self.errorMsg = '请输入密码';
    return false;
  }
  if (!/^(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z;,?.*^%￥#!@()]{6,20}$/.test(password)) {
    self.errorMsg = '请输入必须包含大小写的6-20位密码，密码可支持的特殊字符 ;,?)(*^%￥#@!';
    return false;
  }
  if (checkPassword === '') {
    self.errorMsg = '请再次输入密码';
    return false;
  }
  if (checkPassword !== password) {
    self.errorMsg = '两次密码输入不一致';
    return false;
  }
  if (mobile === '') {
    self.errorMsg = '请输入手机号';
    return false;
  }
  if (!/^1[0-9]{10}$/.test(mobile)) {
    self.errorMsg = '手机号格式错误';
    return false;
  }
  if (authCode === '') {
    self.errorMsg = '请输入验证码';
    return false;
  }
  self.errorMsg = '';
  return true;
};

// 登录信息表单校验
const checkLoginFormFormat = function(self) {
  if (self.loginForm.userName === '') {
    self.errorMsg = '请输入用户名';
    return false;
  }
  if (self.loginForm.passWord === '') {
    self.errorMsg = '请输入密码';
    return false;
  }
  if (self.loginForm.imageData === '') {
    self.errorMsg = '请输入验证码';
    return false;
  }
  self.errorMsg = '';
  return true;
};

// 重置密码表单校验
const checkResetFormFormat = function(self) {
  const { passWord, checkPassword } = self.resetForm;
  if (!/^(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z;,?.*^%￥#!@()]{6,20}$/.test(passWord)) {
    self.errorMsg = '请输入必须包含大小写的6-20位密码，密码可支持的特殊字符 ;,?)(*^%￥#@!';
    return false;
  }
  if (checkPassword !== passWord) {
    self.errorMsg = '两次输入不一致';
    return false;
  }
  self.errorMsg = '';
  return true;
};

// 手机号格式校验
const checkMobileFormat = function(self) {
  const { mobile } = self.registerForm;
  if (mobile === '') {
    self.errorMsg = '请输入手机号';
    return false;
  }
  if (!/^1[0-9]{10}$/.test(mobile)) {
    self.errorMsg = '手机号格式错误';
    return false;
  }
  self.errorMsg = '';
  return true;
};

export { checkRegisterFormFormat, checkLoginFormFormat, checkResetFormFormat, checkMobileFormat };
